import { Component } from '@angular/core';

@Component({
    selector: 'app-differed-decision-introduction',
    templateUrl: './differed-decision-introduction.component.html',
    styleUrls: ['./differed-decision-introduction.component.scss'],
})
export class DifferedDecisionIntroductionComponent {
    showFaqModal = false;

    toggleFaq() {
        this.showFaqModal = !this.showFaqModal;
    }
}
